import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const question = [
  {
    field: 'pruritusAni_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    field: 'pruritusAni_nonConsent',
    isLast: true,
    label: `We understand that you do not consent. Please seek in-person care and a refund will process between 5 - 10 business days`,
    extras: { sendToBeluga: false },
    blockQuestionFlow: true,
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'pruritusAni_ineligible',
    label: "We're sorry you don't qualify.",
    subLabel:
      'Based on your responses, there are concerning signs that go beyond what can be safely managed remotely. Please seek in-person medical care as soon as possible. It’s important to rule out anything more serious and ensure you get the right treatment. A refund will process between 5 - 10 business days.',
    extras: { sendToBeluga: false },
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'pruritusAni_sex',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'male',
          value: 'Male'
        },
        {
          key: 'female',
          value: 'Female'
        }
      ]
    }
  },
  {
    label: 'Are you currently pregnant or planning to become pregnant?',
    field: 'pruritusAni_pregnant',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Which trimester are you in?',
    field: 'pruritusAni_trimester',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'first',
          value: 'First trimester (weeks 0–13)'
        },
        {
          key: 'second',
          value: 'Second trimester (weeks 14–27)'
        },
        {
          key: 'third',
          value: 'Third trimester (weeks 28–delivery)'
        },
        {
          key: 'planning',
          value: 'I’m planning on becoming pregnant soon'
        }
      ]
    }
  },
  {
    label: 'Consent (pregnancy)',
    field: 'pruritusAni_consentPregnancy',
    type: 'select',
    educationalSlide:
      'The formulations available through this service have been reviewed and approved by board-certified OB/GYNs and contain only ingredients that, on current evidence, are considered Pregnancy Category C. Pregnancy Category C means that animal studies have shown potential risks to the fetus, but there are no well-controlled studies in pregnant women. You must consult your own prenatal care provider before starting, continuing, or modifying any treatment obtained here to ensure it is appropriate for your specific medical history and gestational stage.',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'No, I do not consent',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value: 'Yes, I have read and consent',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    label: 'What is your height in feet and inches',
    field: 'pruritusAni_height',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'pruritusAni_height'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'pruritusAni_weight',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'pruritusAni_weight'
    }
  },
  {
    label: 'When did the itching first appear?',
    field: 'pruritusAni_firstItch',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'days',
          value: 'Within the past few days'
        },
        {
          key: 'weeks',
          value: 'Several weeks ago'
        },
        {
          key: 'months',
          value: 'Several months ago'
        },
        {
          key: 'year',
          value: 'More than a year ago'
        }
      ]
    }
  },

  {
    label: 'Where do you feel the itch?',
    field: 'pruritusAni_itchLocation',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'around',
          value: 'On the skin around the anus (outside)'
        },
        {
          key: 'inside',
          value: 'Inside the anal canal'
        },
        {
          key: 'both',
          value: 'Both inside and outside'
        }
      ]
    }
  },
  {
    label: 'When is the itch most bothersome?',
    field: 'pruritusAni_whenItchMostBothersome',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'constant',
          value: 'It’s constant, day and night'
        },
        {
          key: 'night',
          value: 'Mainly at night'
        },
        {
          key: 'afterBowel',
          value: 'Right after bowel movements'
        }
      ]
    }
  },
  {
    label: 'Are you noticing any of the following? (Select all that apply)',
    field: 'pruritusAni_OtherSymptoms',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'burning',
          value: 'A burning sensation'
        },
        {
          key: 'pain',
          value: 'Pain in the area'
        },
        {
          key: 'bleeding',
          value: 'Bleeding'
        },
        {
          key: 'none',
          value: 'None of these',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'Do you often have any of the below? (Select all that apply)',
    field: 'pruritusAni_otherIssues',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'constipation',
          value: 'Constipation (hard or infrequent stools)'
        },
        {
          key: 'diarrhea',
          value: 'Diarrhea (loose or frequent stools)'
        },
        {
          key: 'consipationAndDiarrhea',
          value: 'Alternating constipation and diarrhea'
        },
        {
          key: 'incompleteEmptying',
          value: 'A feeling of incomplete emptying'
        },
        {
          key: 'none',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'How many bowel movements do you have per week?',
    field: 'pruritusAni_bowelMovements',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: '0–3',
          value: '0–3'
        },
        {
          key: '4–7',
          value: '4–7'
        },
        {
          key: '8+',
          value: '8 or more'
        }
      ]
    }
  },
  {
    label:
      'Do you regularly eat spicy foods, citrus, caffeine, chocolate, alcohol, or tomatoes?',
    field: 'pruritusAni_diet',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Have you changed your diet in the past month?',
    field: 'pruritusAni_changedDiet',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you changed your activity level recently (more or less exercise than before)?',
    field: 'pruritusAni_activityLevel',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'How do you usually clean after a bowel movement? (check all that apply)',
    field: 'pruritusAni_cleaningMethod',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'dry',
          value: 'Dry toilet paper'
        },
        {
          key: 'wipes',
          value: 'Moist wipes'
        },
        {
          key: 'medicatedWipeOrSoap',
          value: 'Medicated wipes or soap'
        },
        { key: 'bidet', value: 'Bidet / water spray' },
        {
          key: 'other',
          value: 'Other method'
        }
      ]
    }
  },
  {
    label: 'Tell us a bit more about your other method',
    field: 'pruritusAni_moreAboutWipeMethod',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'pruritusAni_moreAboutWipeMethod'
    }
  },
  {
    label:
      'Have you tried any creams, powders, or ointments for your current symptoms?',
    field: 'pruritusAni_prevTreament',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Tell us about which treatment that you have tried and whether it was effective?',
    field: 'pruritusAni_moreAboutPrevTreatment',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'pruritusAni_moreAboutPrevTreatment'
    }
  },
  {
    label: 'Do you wear tight clothing or synthetic underwear?',
    field: 'pruritusAni_clothing',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Do you sweat heavily with work, exercise, or hot weather?',
    field: 'pruritusAni_sweatDuringActivity',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Do you have eczema, psoriasis, or other chronic skin conditions?',
    field: 'pruritusAni_skinCondition',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Tell us more about this condition',
    field: 'pruritusAni_moreAboutSkinCondition',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'pruritusAni_moreAboutSkinCondition'
    }
  },
  {
    label:
      'Do you have any known contact allergies (fragrances, latex, detergents, etc.)?',
    field: 'pruritusAni_contactAllergens',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Tell us more about this allergy',
    field: 'pruritusAni_moreAboutContactAllergens',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'pruritusAni_moreAboutContactAllergens'
    }
  },
  {
    label: 'Do you have any of the below (Select all that apply)',
    field: 'pruritusAni_rectalIssues',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'hemorrhoids',
          value: 'I have hemorrhoids'
        },
        {
          key: 'analFissures',
          value: 'I have anal fissures'
        },
        {
          key: 'anorectalSurgery',
          value: 'I have had anorectal surgery'
        },
        {
          key: 'diabetes',
          value: 'I have diabetes'
        },
        {
          key: 'inflammatoryBowelDisease',
          value: 'I have Inflammatory bowel disease (IBD)'
        },
        {
          key: 'antibioticsOrAntifungals',
          value: 'I have recently used antibiotics or antifungals'
        },
        {
          key: 'receptiveAnalIntercourse',
          value: 'I engage in receptive anal intercourse'
        },
        {
          key: 'STIHistory',
          value: 'I have a history of STIs or high-risk sexual partners'
        },
        {
          key: 'none',
          value: 'I do not have any of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'pruritusAni_otherQuestions',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'pruritusAni_otherQuestions'
    }
  },
  {
    label:
      'Consent (Topical Medications for Hemorrhoids, Anal Fissures, and Pruritus Ani):',
    field: 'pruritusAni_consentTopicalMedication',
    type: 'select',
    educationalSlide: `
    You have reported symptoms consistent with hemorrhoids, anal fissures, pruritus ani, or a combination of these conditions. These may include rectal pain, itching, burning, bleeding, or discomfort with bowel movements. Bummed offers compounded topical medications formulated to relieve these symptoms by targeting inflammation, internal sphincter spasm, nerve irritation, or local infection.

    You are being prescribed a custom-compounded topical formulation that may contain one or more of the following ingredients:

        - Diltiazem, Nifedipine, or Nitroglycerin – reduce anal sphincter tone and improve blood flow, aiding fissure healing and reducing hemorrhoid symptoms
        - Hydrocortisone – reduces localized inflammation and itching
        - Metronidazole – provides anti-inflammatory and antimicrobial effects
        - Lidocaine and Bupivacaine – local anesthetics offering short- and long-acting pain relief
        - Clotrimazole – treats fungal causes of external anal itching

        Common formulations may include:
        - Diltiazem 2% / Hydrocortisone 2% / Lidocaine 5% / Bupivacaine 1%
        - Nitroglycerin 0.1% / Hydrocortisone 2% / Metronidazole 10% / Lidocaine 5% / Bupivacaine 1%
        - Nifedipine 0.5% / Hydrocortisone 2% / Lidocaine 5% / Bupivacaine 1%
        - Clotrimazole 1% / Hydrocortisone 2% (external use only)

        Use During Pregnancy and Breastfeeding:
        - Diltiazem, Nifedipine, Nitroglycerin, Hydrocortisone, Bupivacaine, Metronidazole – Category C
        - Lidocaine – Category B (short-term use generally safe)
        - Clotrimazole – Category B (external fungal conditions)
        
        If you are currently pregnant, trying to conceive, or breastfeeding, please inform your in-person healthcare provider. Use of these compounds should result from a shared decision-making discussion with your provider.


        Expected Benefits:
        - Relief from anal pain, itching, burning, or pressure
        - Promotion of healing in chronic anal fissures
        - Reduction of hemorrhoidal swelling and discomfort
        - Improved comfort during and after bowel movements

        Possible Side Effects:
        - Local irritation, stinging, or redness at the application site
        - Headaches (more common with nitroglycerin)
        - Dizziness or lightheadedness
        - Rare allergic reactions (rash, swelling, sensitivity)

        Alternative Treatments:
        - Warm sitz baths
        - Lifestyle and toileting modifications
        - Topical non-medicated agents (e.g., witch hazel, petroleum jelly)
        - Fiber supplementation and stool softeners
        - In-office procedures (e.g., banding, thrombectomy) if indicated
        
        I understand the potential benefits, risks, and limitations of using these compounded topical medications. I understand that use during pregnancy and breastfeeding requires special consideration and should be guided by my provider. I agree to follow the directions provided and to report any concerning symptoms or lack of improvement.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'No, I do not consent',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value: 'Yes, I have read and consent',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    label: 'Consent (Truthfulness):',
    field: 'pruritusAni_truthfulness',
    type: 'select',
    educationalSlide:
      'Please attest to the following confirming that all information you have provided to us is true and complete.\n\n\nI verify that I am the patient and that I have answered the questions asked in this intake form.  I confirm that I have reviewed and understood all the questions asked of me.  I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor.  I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'No, I do not consent',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value: 'Yes, I have read and consent',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  }
] as const;

const _type = [...question] as const;

export type PruritusAniFieldAnswers = Partial<QuestionAnswerMap<typeof _type>>;

export default question;
